import SidebarItems from "./SidebarItems";
import { useReactable } from "@reactables/react";
import { RxToggle } from "@jauntin/reactables";
import arrowIcon from "../../../Assets/Images/sidebar-arrow-icon.svg";

const Sidebar = ({ referralParams }: { referralParams?: string }) => {
  const [show, { toggle: toggleSidebar }] = useReactable(RxToggle, true);

  return (
    <div
      className={`sidebar p-1 d-none d-sm-none d-md-none d-lg-none d-xl-flex ${
        show ? "sidebar-open" : "sidebar-closed"
      }`}
    >
      <SidebarItems referralParams={referralParams} />
      <button type="button" onClick={toggleSidebar} className="sidebar__button">
        <img src={arrowIcon} alt="" />
        <img src={arrowIcon} alt="" />
        <img src={arrowIcon} alt="" />
      </button>
    </div>
  );
};

export default Sidebar;
